import React from 'react';
import {
  FormPageAuthInputItemMonthDayFree,
  FormPageAuthInputItemMonthDay,
  MonthDayAuthPropertyFree,
  MonthDayAuthProperty,
  MONTH_DAY_AUTH_PROPERTY_TYPE,
} from 'shared';
import { FormFieldInputProps } from '../shared';
import { MonthDayFree } from './MonthDayFree';

type MonthDayInputProps = FormFieldInputProps<
  MonthDayAuthProperty,
  FormPageAuthInputItemMonthDay
>;

export const MonthDayInput: React.FC<MonthDayInputProps> = (props) => {
  switch (props.property.detail.inputFormat.inputFormatType) {
    case MONTH_DAY_AUTH_PROPERTY_TYPE.free: {
      const { value, property, disabled, design, onChange, onBlur } =
        props as FormFieldInputProps<
          MonthDayAuthPropertyFree,
          FormPageAuthInputItemMonthDayFree
        >;
      return (
        <MonthDayFree
          monthValue={value.month}
          dayValue={value.day}
          property={property}
          disabled={disabled}
          design={design}
          onChange={onChange}
          onBlur={onBlur}
        />
      );
    }
    default: {
      return null;
    }
  }
};
